// Translated labels for JavaScript that has no element to carry them as Stimulus values
// (global dropdown and search messages, the clipboard confirmation, fallbacks of controllers
// used without a value).
// They are rendered once per page by application/_head (<meta name="js-labels">, keys
// application.head.js_labels.*, in the user's language). Anything tied to an element
// takes its labels from Stimulus values instead.
// Read at each call, never kept: a Turbo visit replaces the meta, so a tab opened before the
// language changed in another tab speaks the new language from its next page on.
export default function label(key: string): string {
  const meta = document.querySelector<HTMLMetaElement>('meta[name="js-labels"]')
  const labels = JSON.parse(meta?.content || '{}') as Record<string, string>
  return labels[key] ?? ''
}
